/**
 * @file Orientation.ts
 * @role The orientation type + the single function that decides orientation from a
 *       width/height. Centralizing this kills scattered `innerWidth > innerHeight` checks.
 * @owns Orientation type and orientationForSize().
 * @invariants 14 (no hardcoded orientation checks in components).
 * @see docs/INVARIANTS.md
 */
export type Orientation = 'portrait' | 'landscape';

export function orientationForSize(width: number, height: number): Orientation {
  return width >= height ? 'landscape' : 'portrait';
}
